// extracted by mini-css-extract-plugin
export var borderRadius = "_66-4";
export var large = "_66-3";
export var logoContainer = "_66-0";
export var nameLogo = "_66-2";
export var small = "_66-1";